<template>
    <div>
        <missing-sample-item v-for="missingSample in missingSamples" :key="missingSample.id"
                      :data="missingSample"></missing-sample-item>
        <div class="cleaner"></div>
    </div>
</template>

<script>
    import MissingSampleItem from './MissingSampleItem'
    export default {
        name: 'MissingSamplesList',
        props: {
            missingSamples: Array
        },
        components: {
            MissingSampleItem
        }
    }
</script>

<style scoped>

</style>